export class ChaseProfileTransactionData {
    ChaseOrderId: string;
    TransactionAmount: string;
    ProfileReference: string;
    PaymentType: string;
}



// WEBPACK FOOTER //
// ./src/app/external-user/Model/ChaseProfileTransactionData.ts